import { createConfiguredApiInstance } from '../utils/axios-factory';

const apiInventory = createConfiguredApiInstance({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_INVENTRY_URL!,
  timeout: 120000,
});

export default apiInventory;
